module.exports = __webpack_public_path__ + "media/assets/images/flags/uz-1ec92f3e89287c4319e9dd1d427741d9.svg";